import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DateRangeField from "@/components/controls/DateRangeField";
import { cn } from "@/utils/utils";
import {
  FIELD_CLASSNAME,
  FOCUS_CLASSNAME,
  HALF_WRAPPER_CLASSNAME
} from "../shared";
import { ControlProps, DateRangeControlValue } from "../types";

export const DateRangeControl: React.FC<ControlProps> = ({
  value,
  onChange,
  name
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const range =
    value && typeof value === "object" && "fromDate" in value
      ? (value as DateRangeControlValue)
      : undefined;

  return (
    <div className={HALF_WRAPPER_CLASSNAME}>
      <DateRangeField
        fieldKey={name}
        value={range}
        onUpdate={onChange}
        placeholder={t("questionnaire.placeholders.selectDateRange")}
        placeholderVariant="bodyTertiary"
        className={cn(FIELD_CLASSNAME, isOpen && FOCUS_CLASSNAME)}
        alwaysShowIcon
        isOpen={isOpen}
        onOpenChange={setIsOpen}
      />
    </div>
  );
};
